import { ISmartFieldChange } from "@components/smart/smartField/SmartField";
import {
    IPrCSSZSubmissionPaternityLeaveEntity,
    PrCareReceiverEntity,
    PrCSSZSubmissionPaternityLeaveDetailEntity,
    PrCSSZSubmissionPaternityLeaveEntity
} from "@odata/GeneratedEntityTypes";
import { PrSubmissionSubtypeCode, PrSubmissionTypeCode } from "@odata/GeneratedEnums";
import {
    handleIdentificationTypeBeforeSave,
    initIdentificationTypeLocalPath
} from "@pages/payroll/employee/Employee.utils";
import {
    handleWorkedInDaysChange,
    initReturnToWorkLocalContext,
    initWorkedInDays
} from "@pages/payroll/submission/submissionTypes/PrCSSZSubmission.utils";
import PrCSSZSubmissionNEMPRIFormView from "@pages/payroll/submission/submissionTypes/PrCSSZSubmissionNEMPRIFormView";

import { withPermissionContext } from "../../../../contexts/permissionContext/withPermissionContext";

class PrCSSZSubmissionPaternityLeaveFormView extends PrCSSZSubmissionNEMPRIFormView<IPrCSSZSubmissionPaternityLeaveEntity> {
    typeCode = PrSubmissionTypeCode.EmployersNotificationOfAnEmployeesBenefitApplication;
    subTypeCode = PrSubmissionSubtypeCode.NempriPaternityLeave;

    typeSpecificOnAfterLoad(isNew: boolean): Promise<void> {
        const { storage } = this.props;

        // init local contexts from data
        initIdentificationTypeLocalPath(storage,
            storage.data.bindingContext
                .navigate(PrCSSZSubmissionPaternityLeaveEntity.Detail)
                .navigate(PrCSSZSubmissionPaternityLeaveDetailEntity.CareReceiver),
            PrCareReceiverEntity.IdentificationNumber
        );

        initReturnToWorkLocalContext(storage);
        initWorkedInDays(storage);

        return super.typeSpecificOnAfterLoad(isNew);
    }

    handleChange(e: ISmartFieldChange): void {
        const { storage } = this.props;
        handleWorkedInDaysChange(e, storage);

        super.handleChange(e);
        // keep after storage -> handleChange to have updated data
    }

    onBeforeSave(data?: IPrCSSZSubmissionPaternityLeaveEntity): IPrCSSZSubmissionPaternityLeaveEntity {
        const { storage } = this.props;
        data = super.onBeforeSave(data);

        const careReceiverBc = storage.data.bindingContext
            .navigate(PrCSSZSubmissionPaternityLeaveEntity.Detail)
            .navigate(PrCSSZSubmissionPaternityLeaveDetailEntity.CareReceiver);
        handleIdentificationTypeBeforeSave(data, storage.data.bindingContext, careReceiverBc, {
            identificationPropName: PrCareReceiverEntity.IdentificationNumber
        });

        return data;
    }
}

export default withPermissionContext(PrCSSZSubmissionPaternityLeaveFormView);